import ProductCardV2Colors from '@components/Product/components/ProductCardV2/components/ProductCardV2Colors';
import { useProductCardV2Styles } from '@components/Product/components/ProductCardV2/productCardV2.styles';
import ProductMediaEmptyState from '@components/Product/components/ProductMediaEmptyState/ProductMediaEmptyState';
import LabeledChip from '@components/v2/ui/LabeledChip/LabeledChip';
import { ReactNode } from 'react';
import { RachelProductCardsTestIds } from '../../../../../../../utils/testIds/RachelProductCards.testIds';
import MediaRenderer from '../../../../../../media/MediaRenderer';
import {
  ProductCardsColorsConfig,
  ProductCardsPriceConfig,
  ProductCardsSummary,
} from '../../productCardsBlock.types';
import ProductCardsHeading from '../ProductCardsHeading/ProductCardsHeading';
import ProductCardsPrice from '../ProductCardsPrice/ProductCardsPrice';
import { useRachelProductCardStyles } from './rachelProductCard.styles';
import { useRachelProductCard } from './useRachelProductCard';

interface RachelProductCardProps {
  product: ProductCardsSummary;
  colors: ProductCardsColorsConfig;
  price: ProductCardsPriceConfig;
  onClick: () => void;
  action?: ReactNode;
}

const RachelProductCard = ({ product, colors, price, action, onClick }: RachelProductCardProps) => {
  const { classes } = useRachelProductCardStyles();
  const { classes: cardClasses } = useProductCardV2Styles({});
  const { mediaSrc, aspectRatio } = useRachelProductCard(product.imageUrl);

  return (
    <div role="listitem" test-id={RachelProductCardsTestIds.CARD} className={classes.root}>
      <div className={cardClasses.mediaContainer}>
        {mediaSrc ? (
          <MediaRenderer src={mediaSrc} aspectRatio={aspectRatio} alt="" loading="lazy" />
        ) : (
          <ProductMediaEmptyState aspectRatio={aspectRatio} />
        )}
        {!!product.tag && (
          <div className={classes.tagOverlay}>
            <LabeledChip
              appearance="overlay"
              content={product.tag}
              title={product.tag}
              className={classes.tag}
            />
          </div>
        )}
      </div>

      <div className={classes.info}>
        <div className={classes.header}>
          <div className={classes.heading}>
            <ProductCardsHeading
              name={product.name}
              code={product.code}
              referenceCode={product.referenceCode}
              variant="card"
              onOpen={onClick}
            />
          </div>
          {action && <div className={classes.action}>{action}</div>}
        </div>

        <div className={classes.colors}>
          <ProductCardV2Colors
            allColors={colors.options}
            selectedColor={colors.selected}
            onColorClick={colors.onSelect}
          />
        </div>

        {price.isVisible && (
          <ProductCardsPrice
            prices={price.prices}
            isRetailDisabled={price.isRetailDisabled}
            isWholesaleDisabled={price.isWholesaleDisabled}
          />
        )}
      </div>
    </div>
  );
};

export default RachelProductCard;
